import { Component } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
	selector: 'app-messages',
	templateUrl: './messages.component.html',
	styleUrls: ['./messages.component.css']
})
export class MessagesComponent
{
	constructor(private messageService: MessageService)
	{
	}
}



// WEBPACK FOOTER //
// ./src/app/messages/messages.component.ts